import { getClassNameForField, projectCategoriesFields as fields } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'

const ProjectCategoriesCreate = () => {
    const { translateFields } = useTranslationService()
    const projectCategoriesFields = translateFields(fields, 'project_categories')

    return (
        <>
            <EditableFormPage
                submitUrl='admin/project-categories'
                fields={projectCategoriesFields}
                classNameForField={getClassNameForField}
                create={true}
                navigateLink='/admin/auth/project-categories'
            />
        </>
    )
}

export default ProjectCategoriesCreate
